// extracted by mini-css-extract-plugin
export default {"container":"adminBubble_container__HD6ib","primary":"adminBubble_primary__KPlXr","secondary":"adminBubble_secondary__vnQwX"};